import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export type { ICashbackDetailsV2 } from "./CashbackDetailsV2";

export default lazyLoadComponentFactory(
    () => import(/* webpackChunkName: "cashback-details-modal" */ "./CashbackDetailsV2"),
);
